import React, {useContext, useState, useEffect, useRef} from 'react'
import {Modal, Input, Row, Col, Select, Button, Table, Form, notification } from 'antd'
import { FaInfoCircle } from "react-icons/fa";

const { Option } = Select;
const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };
  
  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
  
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
  
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({ ...record, ...values });
      } catch (errInfo) {
      }
    };
  
    let childNode = children;
  
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} es requerido.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
  
    return <td {...restProps}>{childNode}</td>;
  };

function ProductModalStorage(props){
    const[plantId, setPlantId] = useState("S");
    const[dataTableStorage, setDataTableStorage] = useState([]);
    const[tableStorageLoading, setTableStorageLoading] = useState(false);
    const[selectedRowKeysStorage, setSelectedRowKeysStorage] = useState([]);
    const[btnLoading, setBtnLoading] = useState(false);

    useEffect(() => {
      setPlantId(props.idPlant);
      setSelectedRowKeysStorage(props.dataKeysStorage);
      setDataTableStorage(props.dataTableStorage);
    },[props.dataKeysStorage])

    function handleChangePlant(value) {
        setDataTableStorage([]);
        setPlantId(value);
        if(value !== "S"){
            setTableStorageLoading(true);
            const dataStorage = [];
            const data = props.dataPlantsStorage.find(x => x.id === value);
            data.storageLocations.map(function(obj){
                const row = {
                    id: obj.id,
                    storageLocationId: obj.id,
                    almacen: obj.name,
                    stock: 0,
                    safeStock: 0
                };
                const ps = props.dataProductStorage.filter(p => p.storageLocationId === obj.id);
                if(ps.length > 0){
                    row.stock = ps.stock;
                    row.safeStock = ps.safeStock;
                }
                dataStorage.push(row);
                return true;
            });
            setDataTableStorage(dataStorage);
            setTableStorageLoading(false);
        }
        
    }

    const handleOk = async () => {
        setBtnLoading(true);
        const data = [...selectedRowKeysStorage];
        const datast = [...dataTableStorage];
        const storages = [];
        data.map(function(obj){
          const item = datast.filter(x => x.id === obj);
          if(item.length > 0){
            const row = {
              StorageLocationId: item[0].storageLocationId,
              Stock: item[0].stock,
              SafeStock: item[0].safeStock
            }
            storages.push(row);
          }
          return true;
        });
        await props.handleOkModalStorage(plantId,storages);
        setDataTableStorage([]);
        setBtnLoading(false);
        
    }

    const handleCancel = () => {
        setDataTableStorage([]);
        props.handleCancelModalStorage();
    }

    const handleSave = (row) => {
        if(parseFloat(row.stock) >= 0 && parseFloat(row.safeStock) >= 0){
            row.stock = parseFloat(row.stock);
            row.safeStock = parseFloat(row.safeStock);
            const newData = [...dataTableStorage];
            const index = newData.findIndex((item) => row.id === item.id);
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row });
            setDataTableStorage(newData);
        }
        
    };

    const columns = [
        {
          title: "Información",
          render: (record) => (
            <React.Fragment>
              {record.id}
              <br />
              {record.almacen}
            </React.Fragment>
          ),
          responsive: ["xs"]
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            responsive: ["sm"]
        },
        {
            title: 'Almacén',
            dataIndex: 'almacen',
            responsive: ["sm"]
        },
        {
            title: 'Stock',
            dataIndex: 'stock',
            //editable: true,
            
        },
        {
            title: 'Stock de seguridad',
            dataIndex: 'safeStock',
            editable: true,
            
        },
          
    ];

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const columnss = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
    
        return {
            ...col,
            onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave: handleSave,
            }),
        };
    });

    const onSelectChangeStorage = (selectedRowKeys) => {
      // Unselected items with stock
      const unselected = props.dataKeysStorage.filter(x => !selectedRowKeys.includes(x)
        && dataTableStorage.some(dts => dts.id === x && dts.stock !== 0));

      // Select again unselected items with stock
      setSelectedRowKeysStorage([...selectedRowKeys, ...unselected]);

      // If there are not unselected items with stock, exit method.
      if(!unselected.length) return;

      notification["warning"]({
        message: "Producto",
        description: 'No es posible deshabilitar productos de almacén cuando el stock es diferente de 0.'
      });
    };
        
    const rowSelectionStorage = {
      selectedRowKeys: selectedRowKeysStorage,
      onChange: onSelectChangeStorage,
    };


    return(
        <React.Fragment>
            <Modal title="Almacenes del producto" 
            visible={props.modalVisibleStorage} 
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk} loading={btnLoading}>
                  Guardar
                </Button>
              ]}
            width={800}>
                <Row>
                    <Col span={24}>
                        <Input value={props.nameProduct} placeholder="Nombre" disabled/>
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Select value={props.idPlant} style={{ width: '100%', display:'none' }} onChange={handleChangePlant}>
                            <Option value="S">Selecciona una planta</Option>
                            {props.dataPlantsStorage.map(function(obj){
                                return <Option key={obj.id} value={obj.unit}>{obj.name}</Option>
                            })}
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <br/>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Table rowKey="id" 
                            components={components} 
                            rowClassName={() => 'editable-row'}
                            dataSource={dataTableStorage} 
                            columns={columnss} 
                            rowSelection={rowSelectionStorage}
                            loading={tableStorageLoading}/>
                            <p><FaInfoCircle/> Para modificar la cantidad debes dar clic en la celda que contiene el valor.</p>
                            <p><FaInfoCircle/> Los almacenes seleccionados son los que estan asignados al producto.</p>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default ProductModalStorage;


// WEBPACK FOOTER //
// ./src/components/ProductModalStorage.jsx